import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import React, { Component } from "react";
import { withStyles } from "material-ui/styles";
import Grid from "material-ui/Grid";
import Header from "components/Header";
import Footer from "components/Footer";
import Horaires from "components/Horaires";
import Place from "components/Place";
import Carte from "components/Carte";
import Moyens from "components/Moyens";
import DishImageGallery from "./components/DishImageGallery";

const styles = (theme) => ({
  root: {
    height: "100%",
  },
  body: {
    flexGrow: 1,
    padding: 15,
  },
});

class App extends Component {
  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Header />

        <div className={classes.body}>
          <Grid container justify="center" spacing={24}>
            <DishImageGallery />
            <Carte />
          </Grid>
          <Grid container justify="center" spacing={24}>
            <Horaires />
            <Place />
          </Grid>
          <Grid container justify="center" spacing={24}>
            <Moyens />
          </Grid>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withStyles(styles)(App);



// WEBPACK FOOTER //
// ./src/App.js